module.exports = __webpack_public_path__ + "img/venom.10bbc516.png";